module.exports = __webpack_public_path__ + "static/media/icon-senior-female.b52dab06.svg";